import * as React from 'react'

import classNames from 'classnames'

import './index.styles.css'

interface Props {
  highlighted?: boolean
  onClick?: () => void
  compact?: boolean
}

export default function ListItem({
  children,
  compact,
  onClick,
  highlighted,
}: React.PropsWithChildren<Props>) {
  if (!children) return null

  const className = classNames('_ListItem_item', {
    _ListItem_compact: compact,
    _ListItem_highlighted: highlighted,
    _ListItem_onClick: onClick,
  })

  const content = (
    <div className={'_ListItem_content'}>
      <div className={'_ListItem_wrapper'}>{children}</div>
    </div>
  )

  return (
    <div onClick={onClick} className={className}>
      {content}
    </div>
  )
}
